// extracted by mini-css-extract-plugin
module.exports = {"travelAlert":"TravelAlert-module__travelAlert___blH8U","travelAlertLink":"TravelAlert-module__travelAlertLink___liBCt"};